/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiesunnamed1Inputs */

const en_opportunitiesunnamed1 = /** @type {(inputs: Opportunitiesunnamed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unmapped area`)
};

const de_opportunitiesunnamed1 = /** @type {(inputs: Opportunitiesunnamed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unerschlossenes Gebiet`)
};

/**
* | output |
* | --- |
* | "Unmapped area" |
*
* @param {Opportunitiesunnamed1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesunnamed1 = /** @type {((inputs?: Opportunitiesunnamed1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesunnamed1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesunnamed1(inputs)
	return de_opportunitiesunnamed1(inputs)
});
export { opportunitiesunnamed1 as "opportunitiesUnnamed" }